export default __webpack_public_path__ + "static/media/kids2.5c7d1be2.jpg";